import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
} from 'react-admin';

const EnvironmentCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="slug" />
            <ReferenceInput 
                label="Project" 
                source="project_id" 
                reference="projects" 
                sort={{ field: 'name', order: 'ASC' }}
                perPage={100}>
                <SelectInput optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);

export default EnvironmentCreate;